import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelInformationsModalComponent } from './hotel-informations-modal.component';
import { LoaderModule } from '../../../component/loader/loader.module';
import { UIModule } from '../../../ui/ui.module';
import { OffersModule } from '../offers/offers.module';
import { InformationsModule } from '../informations/informations.module';
import { DescriptionModule } from '../description/description.module';
import { HotelResumeModule } from '../hotel-resume/hotel-resume.module';
import { MenuDetailsModule } from '../menu-details/menu-details.module';
import { MapModule } from 'libraries/map/map.module';
import { LanguageService } from 'libraries/service/language/language.service';
import { PermissionModule } from 'libraries/permission/permission.module';
import { HotelCurrencyModule } from 'libraries/service/hotel-currency/hotel-currency.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { ModalModule } from "libraries/ui_modal/Modal.module";
import { HotelInformationsAlternativeSelectComponent } from 'libraries/hotel/components/hotel-informations-modal/components/hotel-informations-alternative-select.component';
import { SimpleSelectModule } from 'libraries/module/formbuilder/fields/simple-select/simple-select.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HotelInformationsModalService } from './service/hotel-informations-modal.service';
import { ExternalServiceModule } from 'libraries/service/external-service/external-service.module';
import { ToMarkerPointModule } from "libraries/pipes/to-marker-point/to-marker-point.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        DescriptionModule,
        ExternalServiceModule,
        FontAwesomeModule,
        HotelCurrencyModule,
        HotelResumeModule,
        InformationsModule,
        LoaderModule,
        MapModule,
        MenuDetailsModule,
        ModalModule,
        NotificationModule,
        OffersModule,
        PermissionModule,
        ReactiveFormsModule,
        SimpleSelectModule,
        ToMarkerPointModule,
        UIModule,
    ],
    exports: [
        HotelInformationsModalComponent,
        HotelInformationsAlternativeSelectComponent,
    ],
    declarations: [
        HotelInformationsModalComponent,
        HotelInformationsAlternativeSelectComponent,
    ],
    providers: [
        LanguageService,
        HotelInformationsModalService,
    ]
})
export class HotelInformationsModalModule {
}
